document.addEventListener("DOMContentLoaded", function () {

    const slider = document.querySelector(".department-slider");

    if (!slider) return;

    const items = slider.querySelectorAll(".department-category-item");

    if (!items.length) return;

    /* -----------------------------
       Center active category
    ------------------------------*/

    const activeItem = slider.querySelector(".department-category-item.active");

    if (activeItem) {
        setTimeout(() => {
            activeItem.scrollIntoView({
                behavior: "smooth",
                inline: "center",
                block: "nearest"
            });
        }, 300);
    }

    /* -----------------------------
       Responsive items per view
    ------------------------------*/

    function getItemsPerView() {
        if (window.innerWidth < 768) return 2;
        if (window.innerWidth < 1200) return 4;
        return 5;
    }

    /* -----------------------------
       Create pagination dots
    ------------------------------*/

    const oldDots = document.querySelector(".department-slider-dots");

    if (oldDots) oldDots.remove();

    const dotsContainer = document.createElement("div");
    dotsContainer.className = "department-slider-dots";

    slider.parentNode.appendChild(dotsContainer);

    let currentItems = getItemsPerView();
    let totalPages = Math.ceil(items.length / currentItems);

    function createDots() {

        dotsContainer.innerHTML = "";

        currentItems = getItemsPerView();
        totalPages = Math.ceil(items.length / currentItems);

        for (let i = 0; i < totalPages; i++) {

            const dot = document.createElement("div");
            dot.className = "department-slider-dot";

            if (i === 0)
                dot.classList.add("active");

            dot.addEventListener("click", () => {

                const target = items[i * currentItems];

                if (target) {

                    slider.scrollTo({
                        left: target.offsetLeft,
                        behavior: "smooth"
                    });

                }

            });

            dotsContainer.appendChild(dot);

        }

    }

    createDots();

    /* -----------------------------
       Update active dot while scrolling
    ------------------------------*/

    let scrollTimer;

    slider.addEventListener("scroll", function () {

        clearTimeout(scrollTimer);

        scrollTimer = setTimeout(() => {

            const page = Math.round(slider.scrollLeft / slider.clientWidth);

            document.querySelectorAll(".department-slider-dot").forEach((dot, index) => {

                dot.classList.toggle("active", index === page);

            });

        }, 50);

    });

    /* -----------------------------
       Recalculate on resize
    ------------------------------*/

    window.addEventListener("resize", function () {

        createDots();

    });
/* -----------------------------
   Auto Slide
------------------------------*/

let autoSlide = setInterval(nextSlide, 3000);

function nextSlide() {

    const firstCard = slider.querySelector(".department-category-item");

    if (!firstCard) return;

    const sliderStyle = window.getComputedStyle(slider);

    const gap = parseInt(sliderStyle.columnGap || sliderStyle.gap) || 0;

    const cardWidth = firstCard.offsetWidth + gap;

    const maxScroll = slider.scrollWidth - slider.clientWidth;

    if (slider.scrollLeft + cardWidth >= maxScroll) {

        slider.scrollTo({
            left: 0,
            behavior: "smooth"
        });

    } else {

        slider.scrollBy({
            left: cardWidth,
            behavior: "smooth"
        });

    }

}

/* Pause on Hover */

slider.addEventListener("mouseenter", () => {
    clearInterval(autoSlide);
});

slider.addEventListener("mouseleave", () => {
    autoSlide = setInterval(nextSlide, 3000);
});

/* Pause while swiping on mobile */

slider.addEventListener("touchstart", () => {
    clearInterval(autoSlide);
});

slider.addEventListener("touchend", () => {
    autoSlide = setInterval(nextSlide, 3000);
});

});